<template>
    <div class="map-container info-windows">
        <google-map
            id="map"
            ref="Map"
            :zoom="zoom"
            :center="center"
            :options="{
                fullscreenControl: false,
                mapTypeControl: true,
                mapTypeControlOptions: {
                    position: 3,
                },
                streetViewControl: false,
                minZoom: 2,
                maxZoom: 20,
                styles: mapStyles,
            }"
        >
            <google-map-marker
                v-for="(infoWindow, index) in itemsWithLocation"
                :title="infoWindow.title"
                :position="infoWindow.location | convertLatLng"
                :key="index"
                :icon="'/img/icons/poi.png'"
                @click="emitClick(infoWindow)"
                @mouseover="toggleInfoWindow(infoWindow)"
                @mouseout="showInfo = false"
            />
            <google-map-infowindow
                :position="infoWindowContext.position"
                :show.sync="showInfo"
                :options="{ maxWidth: 300, pixelOffset: offset }"
            >
                <p>{{ infoWindowContext.title }}</p>
            </google-map-infowindow>
        </google-map>
    </div>
</template>

<script>
import _ from 'underscore';
import MapboxToGoogleMaps from '@/mixins/MapboxToGoogleMaps';
export default {
    name: 'ProjectContentMap',
    mixins: [MapboxToGoogleMaps],
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            map: undefined,
            showInfo: false,
            infoWindowContext: {
                title: 'a title',
                description: 'a description',
                position: {
                    lat: 44.2899,
                    lng: 11.8774,
                },
            },
            defaultZoom: 6,
            center: { lat: 40, lng: -2 },
            mapStyles: [
                {
                    featureType: 'poi',
                    elementType: 'labels',
                    stylers: [{ visibility: 'off' }],
                },
                {
                    featureType: 'landscape.natural',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
                {
                    featureType: 'transit.station.airport',
                    elementType: 'labels.icon',
                    stylers: [
                        {
                            visibility: 'off',
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        itemsWithLocation() {
            return _.chain(this.items)
                .filter((item) => {
                    if (!item.title.length && _.isObject(item.location)) {
                        item.title = this.$t('Constants.TITLE_NEEDED');
                    }
                    return _.isObject(item.location);
                })
                .value();
        },
        bounds() {
            const bounds = new window.google.maps.LatLngBounds();
            _.each(this.itemsWithLocation, (item) => {
                bounds.extend(
                    new window.google.maps.LatLng(
                        MapboxToGoogleMaps.filters.convertLatLng(item.location)
                    )
                );
            });
            return bounds;
        },
        zoom() {
            return this.defaultZoom;
        },
        offset() {
            return new window.google.maps.Size(0, -42);
        },
    },
    watch: {
        items: {
            immediate: false,
            handler() {
                if (this.items && this.items.length) {
                    this.$refs.Map.fitBounds(this.bounds);
                }
            },
        },
    },
    mounted() {
        navigator.geolocation.getCurrentPosition((pos) => {
            this.center = {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            };
        });
    },
    methods: {
        emitClick({ _id }) {
            this.$emit('click', { _id });
        },
        toggleInfoWindow(context) {
            this.infoWindowContext = {
                title: context.title,
                position: {
                    lat: context.location.latitude,
                    lng: context.location.longitude,
                },
            };
            this.showInfo = true;
        },
        resize() {
            console.log('resize called on project content map');
            // this.map.resize();
        },
        centerMapOnObject(item) {
            console.log('in center map', item);
            this.center = MapboxToGoogleMaps.filters.convertLatLng(
                item.location
            );
            this.defaultZoom = 14;
            this.infoWindowContext = {
                title: item.title,
                position: {
                    lat: item.location.latitude,
                    lng: item.location.longitude,
                },
            };
            this.showInfo = true;
        },
    },
};
</script>

<style scoped>
@import '~vuejs-google-maps/dist/vuejs-google-maps.css';
.map-container {
    position: relative;
    height: calc(100vh - 3.2rem) !important;
}
/deep/.gm-style button,
/deep/.gm-style ul > li {
    font-size: 14px !important;
}
/deep/.gm-style {
    font-family: 'Open sans', sans-serif;
}
/deep/button.gm-ui-hover-effect {
    visibility: hidden;
}
</style>
